import { AlertsProvider } from '@spritz-finance/ui'
import React from 'react'
import { GrowsurfProvider } from '../../context/useGrowsurf'
import { ScreenSizeProvider } from '../../context/useScreenSize'
import { SpritzThemeProvider } from '../../context/useTheme'
import { FontSelector } from '../../theme/fonts/FontSelector'
import { useHotjar } from '../../utils/hotjar/useHotjar'
import { AuthorizedApolloProvider } from './apollo'
import './App.css'
import { AuthProvider } from './auth'
import { AppRoutes } from './routes'
import { useAttribution } from './attribution'
import { useHighlight } from '../../utils/highlight/useHighlight'

const App: React.VFC = () => {
    useHotjar()
    useHighlight()
    useAttribution()
    return (
        <>
            <FontSelector />
            <SpritzThemeProvider>
                <AuthProvider>
                    <ScreenSizeProvider>
                        <AlertsProvider>
                            <AuthorizedApolloProvider>
                                <GrowsurfProvider>
                                    <AppRoutes />
                                </GrowsurfProvider>
                            </AuthorizedApolloProvider>
                        </AlertsProvider>
                    </ScreenSizeProvider>
                </AuthProvider>
            </SpritzThemeProvider>
        </>
    )
}

export default App
